import { enviaMsgSucesso } from "../helpers/Notificacoes";
import api from "../config/api";
import { tratarErroRequisicao } from "../helpers/Errors";

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export class AuthService {
    private readonly baseUrl: string;
    private readonly onUnauthorized?: () => void;

    constructor(onUnauthorized?: () => void) {
        this.baseUrl = REACT_APP_BASE_URL!;
        this.onUnauthorized = onUnauthorized;
    }

    async login(dataLogin: DataLogin, path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.post(path, dataLogin, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Login", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async solicitaAuthAdm(dataLogin: { [key in string]: unknown }, path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.post(path, dataLogin, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Solicitar auth admin", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }


    async redefinirSenha(email: TipoResetSenha, path: string) {
        try {
            const response = await api.post(path, email, {
                signal: this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Redefinicao de senha solicitada", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async criaNovaSenha(password: string, token: string, path: string) {
        try {
            const response = await api.patch(path, { password }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                signal: this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Senha redefinida", response.data);

        } catch (error) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    async executarRefresh(): Promise<boolean> {
        try {
            const resposta = await api.post('/v1/auth/refresh', {}, {
                headers: { 'Content-Type': 'application/json' }
            });

            return resposta.status >= 200 && resposta.status < 300;
        } catch (erro) {
            console.error("Erro crítico ao tentar renovar token:", erro);
            return false;
        }
    }

    async logout(path: string, options: RequestInit = {}) {
        try {
            const customHeaders = options.headers ? (options.headers as Record<string, any>) : {};

            const response = await api.delete(path, {
                headers: { ...customHeaders },
                signal: options.signal || this.createTimeoutSignal(10000),
            });

            return enviaMsgSucesso(200, "Logout", response.data);

        } catch (error: any) {
            return tratarErroRequisicao(error, path, this.onUnauthorized);
        }
    }

    private createTimeoutSignal(timeout: number): AbortSignal | undefined {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeout);
        return controller.signal;
    }

}

interface DataLogin {
    email: string;
    password: string;
}

interface TipoResetSenha {
    email: string;
}